﻿import window from 'window';
import document from 'document';
import { eventBus } from '../../foundation/eventBus';

export const webchat = () => {

    var interactJsUrl = "https://cdn.jsdelivr.net/npm/interactjs@1.5.4/dist/interact.min.js";

    var selectors = {
        root: "[data-component='webchat']"
    };

    var events = {
        scriptLoaded: "webchat:script-loaded",
        chatButtonCreated: "webchat:chat-button-created"
    };
    
    function isIE11() {
        return window.navigator.userAgent.indexOf("Trident/7.0") > -1;
    }

    function getViewportRect() {
        var rightOffset = isIE11() ? 16 : 0;

        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;

        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = document.documentElement.clientHeight;

        var left = scrollX + 1;
        var right = scrollX + viewportWidth - 1 - rightOffset;
        var top = scrollY + 1;
        var bottom = scrollY + viewportHeight - 1;

        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom,
            width: right - left,
            height: bottom - top
        };
    }
    
    function initialiseDraggable() {
        var webchatContainer = document.querySelector(selectors.root);

        if (webchatContainer && webchatContainer.firstElementChild && typeof interact === "function") {
            var webchat = webchatContainer.firstElementChild;

            interact(webchat).draggable({
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: function () {
                            var rect = getViewportRect();
                            return rect;
                        },
                        endOnly: true
                    })
                ],
                onmove: function (event) {
                    var x = (parseFloat(webchat.getAttribute('data-x')) || 0) + event.dx;
                    var y = (parseFloat(webchat.getAttribute('data-y')) || 0) + event.dy;

                    webchat.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

                    webchat.setAttribute('data-x', x);
                    webchat.setAttribute('data-y', y);
                }
            }).on('tap', function () {
                var link = webchat.querySelector('a');

                if (link) {
                    var evt = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    evt.source = 'tap';

                    link.dispatchEvent(evt);
                }

            }).on('click', function (event) {
                if (event.source !== 'tap') {
                    event.stopPropagation();
                }
            }, true);
        }
    }


    function loadInteractJs() {
        var script = document.createElement('script');
        script.src = interactJsUrl;
        script.onload = function () {
            eventBus.publish(events.scriptLoaded);
        };

        document.head.appendChild(script);
    }

    var onScriptLoaded = function() {
        if (window.lpTag && window.lpTag.events && typeof window.lpTag.events.bind === 'function') {
            window.lpTag.events.bind({
                eventName: "OFFER_DISPLAY",
                appName: "LP_OFFERS",
                func: function () {
                    eventBus.publish(events.chatButtonCreated);
                },
                async: true
            });
        }

        eventBus.publish(events.chatButtonCreated);
    };
    
    var init = function () {
        var component = document.querySelector(selectors.root);

        if (component) {
            eventBus.subscribe(events.scriptLoaded, onScriptLoaded);
            eventBus.subscribe(events.chatButtonCreated, initialiseDraggable);

            loadInteractJs();
        }
    };

    return {
        init: init
    };
};